var map = {
	"./BackBtnLayout.vue": 2012,
	"./BaseLayout.vue": 1121,
	"./ClinicHistorySectionsSidebar.vue": 2016,
	"./ForumNavbar.vue": 2020,
	"./HealthyHabitsLayout.vue": 2033,
	"./InternalReducedLayout.vue": 2037,
	"./Opensalud360Layout.vue": 2042,
	"./OpensaludEmpresasLayout.vue": 2049,
	"./OpensaludLayout.vue": 2053,
	"./OpensaludPacientesLayout.vue": 2057,
	"./OpensaludProfesionalesLayout.vue": 2061,
	"./PrivateLayout.vue": 2065,
	"./PublicExtendedLayout.vue": 2097,
	"./PublicLayout.vue": 2101,
	"./PublicMenuLayout.vue": 2105,
	"./PublicMenuLayoutV2.vue": 177,
	"./PublicMobileMenuLayout.vue": 2109,
	"./PublicReducedLayout.vue": 1201,
	"./PublicReducedLayoutDynamic.vue": 2116,
	"./patient/GoFreedom.vue": 2120,
	"./patient/GoOpensaludpass.vue": 2124,
	"./patient/GoTeleconsultation.vue": 2128,
	"./patient/GoTmc.vue": 2132,
	"./patient/GoWellwo.vue": 2136,
	"./patient/SearchTab.vue": 1303,
	"./professional/customHeader.vue": 1275,
	"./professional/customaFooter.vue": 2140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2011;


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts [A-Z]\w+\.(vue|js)$
// module id = 2011
// module chunks = 116